/*
 * @Author: zhb 1822394027@qq.com
 * @Date: 2022-10-05 11:51:06
 * @LastEditors: zhb 1822394027@qq.com
 * @LastEditTime: 2022-10-05 13:38:58
 * @FilePath: \huayue\src\router\menu.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import HomeView from '@/pages/home/home';
import Privacy from '@/pages/home/privacy';
import StaffManage from '@/pages/product/staff-manage';
import WorkingHours from '@/pages/product/working-hours';
import PayWelfare from '@/pages/product/pay-welfare';
import PersonnelGrow from '@/pages/product/personnel-grow';
import PersonnelRecruit from '@/pages/product/personnel-recruit';
import StrategyOrganize from '@/pages/product/strategy-organize';
import AchievementView from '@/pages/product/achievements';
import CloudPlatform from '@/pages/product/cloud-platform';
import TalentDevelopment from '@/pages/product/talent-development';
import ExternalRecruitment from '@/pages/solution/external-recruitment.vue';
import PieceRateSalary from '@/pages/solution/piece-rate-salary';
import AssessMent from '@/pages/solution/assessment';
import TalentReview from '@/pages/solution/talent-review';
import TargetDecomposition from '@/pages/solution/target-decomposition';
import VirtualOrganization from '@/pages/solution/virtual-organization';
import MobileTerminal from '@/pages/solution/mobile-terminal';
import CustomerCase from '@/pages/customer/customer-case';
import CaseIndex from '@/pages/customer/index/index';
import SoftwareView from '@/pages/content/software';
import ExperienceViwe from '@/pages/content/experience';
import AboutViwe from '@/pages/about/index';
import Infroduction from '@/pages/about/children/brief-infroduction';
import Business from '@/pages/about/children/business-school';
import History from '@/pages/about/children/development-history';
import Culture from '@/pages/about/children/corporate-culture';
import Values from '@/pages/about/children/core-values';
import NewsView from '@/pages/news/index';
import HuayueInfoView from '@/pages/news/children/huayue-info';
import IndustryInfoView from '@/pages/news/children/industry-info';
import ContactUsView from '@/pages/news/children/contactUs';
import DetailsView from '@/pages/news/children/news-details';
import AnalysisView from '@/pages/BlAnalysis/index';
import PlatformView from '@/pages/passPlatform/index';

export const constantRouterMap = [
  {
    path: '/',
    name: 'HomeView',
    component: HomeView,
    children: [],
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy
  },
  {
    path: '/staffmanage',
    name: 'StaffManage',
    component: StaffManage,
  },
  {
    path: '/workinghours',
    name: 'WorkingHours',
    component: WorkingHours,
  },
  {
    path: '/paywelfare',
    name: 'PayWelfare',
    component: PayWelfare,
  },
  {
    path: '/personnelgrow',
    name: 'PersonnelGrow',
    component: PersonnelGrow,
  },
  {
    path: '/personnelrecruit',
    name: 'PersonnelRecruit',
    component: PersonnelRecruit,
  },
  {
    path: '/strategyorganize',
    name: 'StrategyOrganize',
    component: StrategyOrganize,
  },
  {
    path: '/achievementview',
    name: 'AchievementView',
    component: AchievementView,
  },
  {
    path: '/cloudplatform',
    name: 'CloudPlatform',
    component: CloudPlatform,
  },
  {
    path: '/development',
    name: 'TalentDevelopment',
    component: TalentDevelopment,
  },
  {
    path: '/recruitment',
    name: 'ExternalRecruitment',
    component: ExternalRecruitment,
  },
  {
    path: '/pieceratesalary',
    name: 'PieceRateSalary',
    component: PieceRateSalary,
  },
  {
    path: '/assessment',
    name: 'AssessMent',
    component: AssessMent,
  },
  {
    path: '/talentreview',
    name: 'TalentReview',
    component: TalentReview,
  },
  {
    path: '/targetdecomposition',
    name: 'TargetDecomposition',
    component: TargetDecomposition,
  },
  {
    path: '/virtualorganization',
    name: 'VirtualOrganization',
    component: VirtualOrganization,
  },
  {
    path: '/mobileterminal',
    name: 'MobileTerminal',
    component: MobileTerminal,
  },
  {
    path: '/customercase',
    name: 'CustomerCase',
    component: CustomerCase,
  },
  {
    path: '/caseindex/:id',
    name: 'CaseIndex',
    component: CaseIndex,
  },
  {
    path: '/software',
    name: 'SoftwareView',
    component: SoftwareView,
  },
  {
    path: '/experience',
    name: 'ExperienceViwe',
    component: ExperienceViwe,
  },
  {
    path: '/about',
    name: 'AboutView',
    component: AboutViwe,
    redirect: '/about/infroduction',
    children: [
      {
        path: '/about/infroduction',
        name: 'InfroductionView',
        component: Infroduction,
      },
      {
        path: '/about/business',
        name: 'BusinessSchool',
        component: Business,
      },
      {
        path: '/about/hisory',
        name: 'HistoryView',
        component: History,
      },
      {
        path: '/about/culture',
        name: 'CultureView',
        component: Culture,
      },
      {
        path: '/about/values',
        name: 'ValuesView',
        component: Values,
      },
    ],
  },
  {
    path: '/news',
    name: 'NewsView',
    component: NewsView,
    redirect: '/news/huayue',
    children: [
      {
        path: '/news/huayue',
        name: 'HuayueInfoView',
        component: HuayueInfoView,
      },
      {
        path: '/news/industry',
        name: 'IndustryInfoView',
        component: IndustryInfoView,
      },
      {
        path: '/news/contactUs',
        name: 'ContactUsView',
        component: ContactUsView,
      },
    ],
  },
  {
    path: '/news/details/:id',
    name: 'DetailsView',
    component: DetailsView,
  },
  {
    path: '/analysis',
    name: 'AnalysisView',
    component: AnalysisView,
  },
  {
    path: '/passPlatform',
    name: 'PlatformView',
    component: PlatformView,
  }
];
